import { useSyncExternalStore } from "react";

/**
 * Globální stav Jarvise (spec §71): otevření overlaye odkudkoli
 * (topbar, Command Center, incident…) + highlight signál „◉ JARVIS UKAZUJE",
 * který konzumují panely (milestone, blockery, decisions).
 */
export type JarvisHighlight = "blockers" | "milestone" | "decisions" | null;

interface JarvisState {
  open: boolean;
  highlight: JarvisHighlight;
  /** Předvyplněný text vstupu (např. „Probrat s Jarvisem" z Decision Inboxu). */
  prefill: string | null;
}

let state: JarvisState = { open: false, highlight: null, prefill: null };
const listeners = new Set<() => void>();

function setState(next: Partial<JarvisState>) {
  state = { ...state, ...next };
  for (const listener of listeners) listener();
}

export function openJarvis(prefill?: string) {
  setState({ open: true, prefill: prefill ?? null });
}
export function closeJarvis() {
  setState({ open: false, highlight: null, prefill: null });
}
export function setJarvisHighlight(highlight: JarvisHighlight) {
  setState({ highlight });
}

export function useJarvisState(): JarvisState {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => state,
  );
}
